// src/state/UserContext.js
// Filepath: // src/state/UserContext.js
import React, { createContext, useContext, useMemo, useState } from "react";
import mockUser from "../data/mockUser.json";
const UserCtx = createContext(null);
export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const value = useMemo(() => ({ user, setUser, mockUser }), [user]);
  return <UserCtx.Provider value={value}>{children}</UserCtx.Provider>;
}
export const useUser = () => useContext(UserCtx);
